import { useEffect, useState, useCallback } from 'react';
import { TeamLeadLogin } from './TeamLeadLogin';
import { TeamLeadShell } from './TeamLeadShell';

type AuthState = 'unknown' | 'authed' | 'anon';

export function TeamLeadApp(): JSX.Element | null {
  const [auth, setAuth] = useState<AuthState>('unknown');

  const refreshAuth = useCallback(async (): Promise<void> => {
    try {
      const r = await fetch('/api/team-lead/me');
      setAuth(r.ok ? 'authed' : 'anon');
    } catch {
      setAuth('anon');
    }
  }, []);

  useEffect(() => {
    void refreshAuth();
  }, [refreshAuth]);

  if (auth === 'unknown') return null;

  if (auth === 'anon') {
    return <TeamLeadLogin onLogin={() => setAuth('authed')} />;
  }

  return <TeamLeadShell onSignOut={() => setAuth('anon')} />;
}
